import { RequestService } from '@tcc-online/request-service';
import IID from '../../types/IID';

const BASE_URL = '/admin/products';

const AdminDashboardService = {
    getProducts,
    getProjects,
    getProject,
};

type BasePayload = {
    type: number;
};

async function getProducts() {
    return await RequestService.get(`${BASE_URL}`);
}
async function getProjects(
    payload: BasePayload & {
        limit?: number;
        page?: number;
        search?: string;
        archived?: boolean;
    },
) {
    const { type, limit = 10, page = 1, search, archived = false } = payload;
    return await RequestService.get(`${BASE_URL}/${type}/projects`, {
        limit,
        page,
        search,
        archived: archived ? 'true' : 'false',
    });
}
async function getProject(payload: BasePayload & IID) {
    const { type, id } = payload;
    return await RequestService.get(`${BASE_URL}/${type}/projects/${id}`);
}

export default AdminDashboardService;
